import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchTrainingHistoryReport } from "../api/fetchTrainingHistoryReport/fetchTrainingHistoryReportApi";
import {
  FetchTrainingHistoryReportParams,
  TrainingHistoryReportItem,
} from "../api/fetchTrainingHistoryReport/types";
import { AppDispatch, AppThunk } from "@/app/store";

interface TrainingHistoryReportState {
  items: TrainingHistoryReportItem[];
  totalCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: TrainingHistoryReportState = {
  items: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const trainingHistoryReportSlice = createSlice({
  name: "trainingHistoryReport",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    setReport: (
      state,
      action: PayloadAction<{
        items: TrainingHistoryReportItem[];
        totalCount: number;
      }>,
    ) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
    },
  },
});

export const { setLoading, setError, setReport } =
  trainingHistoryReportSlice.actions;

export const fetchTrainingHistoryReportAction =
  (params: FetchTrainingHistoryReportParams = {}): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await fetchTrainingHistoryReport(params);
      dispatch(
        setReport({
          items: response.data,
          totalCount: response.meta?.totalCount ?? 0,
        }),
      );
    } catch (error) {
      dispatch(
        setError(
          error instanceof Error
            ? error.message
            : "Failed to fetch training history report",
        ),
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

export default trainingHistoryReportSlice.reducer;
